import { render, staticRenderFns } from "./ConfirmMentorshipCreationModal.vue?vue&type=template&id=64d52593&scoped=true&"
import script from "./ConfirmMentorshipCreationModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmMentorshipCreationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d52593",
  null
  
)

export default component.exports